// extracted by mini-css-extract-plugin
export default {"ViewStatistics":"ViewStatistics_ViewStatistics__ESHhT","zeroState":"ViewStatistics_zeroState__osu+I"};